import { getElementChildren } from "./getElementChildren";
export function getElementChild(element, selector) {
    var children = getElementChildren(element, selector);
    return children ? children[0] : null;
}
